export default {
  GET_STATE_LICENSES_REQUEST: "GET_STATE_LICENSES_REQUEST",
  DELETE_STATE_LICENSE_REQUEST: "DELETE_STATE_LICENSE_REQUEST",
  CREATE_STATE_LICENSE_REQUEST: "CREATE_STATE_LICENSE_REQUEST",
  SET_STATE_LICENSES: "SET_STATE_LICENSES",
  // INSERTION_PT (for script, do not remove)
};
